import * as formulas from './formulas';

export const metrics = [
  {
    id: 16,
    smallName: {
      ru: 'Пороговый CPC',
      en: 'Maximum CPC'
    },
    fullName: '',
    value: formulas.MaxCPC,
    prefix: {
      ru: '₽',
      en: '€'
    },
    important: true
  },
  {
    id: 17,
    smallName: {
      ru: 'Пороговый CPA',
      en: 'Maximum CPA'
    },
    fullName: '',
    value: formulas.MaxCPA,
    prefix: {
      ru: '₽',
      en: '€'
    },
    important: true
  },
  {
    id: 0,
    smallName: 'ARPPU',      
    fullName: '(Average Revenue Per Paying User)',
    value: formulas.ARPPU,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 1,
    smallName: 'ARPU',
    fullName: '(Average Revenue Per user)',
    value: formulas.ARPU,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 2,
    smallName: 'CPA',      
    fullName: '(Cost Per Acquisition)',
    value: formulas.CPA,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 4,
    smallName: 'CPPU',
    fullName: '(Сost Per Paying User)',
    value: formulas.CPPU,
    prefix: ''
  },
  {
    id: 3,
    smallName: 'Leads',      
    fullName: '(Leads)',
    value: formulas.Leads,
    prefix: ''
  },
  {
    id: 5,
    smallName: 'Buyers',      
    fullName: '(Buyers)',
    value: formulas.Buyers,
    prefix: ''
  },
  {
    id: 6,
    smallName: 'Budget',      
    fullName: '(Budget)',
    value: formulas.Budget,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 7,
    smallName: 'Margin',      
    fullName: '',
    value: formulas.Margin,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 8,
    smallName: 'LTV',
    fullName: '(Life Time Value)',
    value: formulas.LTV,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 9,
    smallName: 'OperatingProfit',
    fullName: '(Operating Profit)',
    value: formulas.OperatingProfit,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 10,
    smallName: 'OperatingMargin',
    fullName: '(Operating Margin)',
    value: formulas.OperatingMargin,
    prefix: '%'
  },
  {
    id: 11,
    smallName: 'ROI',
    fullName: '(Return of Investment)',
    value: formulas.ROI,
    prefix: '%'
  },
  {
    id: 12,
    smallName: '1sRev',
    fullName: '(1st sale Revenue)',
    value: formulas.firstSaleRev,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 13,
    smallName: 'Revenue',
    fullName: {
      ru: '(Revenue (за вычетом COGS))',
      en: '(Revenue without COGS)'
    },
    value: formulas.RevenueWithCOGS,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 14,
    smallName: 'Revenue',
    fullName: {
      ru: '(Revenue (без вычета COGS))',
      en: 'Revenue including COGS)'
    },
    value: formulas.RevenueWithoutCOGS,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 15,
    smallName: 'Gross Profit',
    fullName: '',
    value: formulas.GrossProfit,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 18,
    smallName: 'Profit Per Paying User',
    fullName: '',
    value: formulas.profitPerPayUser,
    prefix: {
      ru: '₽',
      en: '€'
    }
  },
  {
    id: 19,
    smallName: 'Profit',
    fullName: {
      ru: '(выручка с рекламной кампании (канала))',
      en: '(revenue from an advertising campaign (channel))'
    },
    value: formulas.profit,
    prefix: {
      ru: '₽',
      en: '€'
    }
  }
]


// WEBPACK FOOTER //
// ./src/services/metrics.js